// Prototipe Template Mockup Otomatis (hanya Preview): pilih kertas (diingat) + format → unduh SVG/PDF berisi data pesanan & barcode.
// Baca-saja: tidak mengubah mockup final, status FIX/ACC, maupun cetak massal.
import axios from "axios";
import { useState } from "react";
import { FileDown } from "lucide-react";
import { toast } from "sonner";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const TEMPLATE_ENABLED = /preview\.emergentagent\.com/.test(BASE);
const KEY = "tf_mockup_tpl_paper";
const readPaper = () => { try { return localStorage.getItem(KEY) === "A4P" ? "A4P" : "A5L"; } catch { return "A5L"; } };

async function blobError(e) {
  const d = e?.response?.data;
  try {
    const txt = typeof d?.text === "function" ? await d.text()
      : await new Promise((ok, no) => { const fr = new FileReader(); fr.onload = () => ok(fr.result); fr.onerror = no; fr.readAsText(d); });
    return JSON.parse(txt).detail || "Gagal membuat template";
  } catch { return d?.detail || "Gagal membuat template"; }
}

export function MockupTemplateButton({ channel, orderNumber, jobId = "", force = false, defaultPaper = "" }) {
  // Ukuran tersimpan per pekerjaan (bila ada) lebih diutamakan daripada pilihan terakhir di perangkat.
  const [paper, setPaper] = useState(() => defaultPaper || readPaper());
  const [fmt, setFmt] = useState("svg");
  const [busy, setBusy] = useState(false);
  if (!TEMPLATE_ENABLED && !force) return null;
  const pick = (v) => { setPaper(v); try { localStorage.setItem(KEY, v); } catch { /* abaikan */ } };
  const tid = `tpl-${orderNumber}${jobId ? `-${jobId}` : ""}`;
  const download = async () => {
    setBusy(true);
    try {
      const r = await axios.get(`${BASE}/api/mockup-template`, { params: { channel, order_number: orderNumber, job_id: jobId, paper, fmt },
        responseType: "blob", withCredentials: true });
      const warn = JSON.parse(decodeURIComponent(r.headers?.["x-template-warnings"] || "%5B%5D"));
      warn.forEach(w => toast.warning(w, { duration: 8000 }));
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = `template_${orderNumber.replace(/[^A-Za-z0-9_-]+/g, "_")}_${paper}.${fmt}`;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 4000);
    } catch (e) { toast.error(await blobError(e)); } finally { setBusy(false); }
  };
  return <span className="dfm-wrap" onClick={e => e.stopPropagation()} onKeyDown={e => e.stopPropagation()} data-testid={tid}>
    <select value={paper} onChange={e => pick(e.target.value)} aria-label="Ukuran kertas" className="dfm-open" data-testid={`${tid}-paper`}>
      <option value="A5L">A5 Landscape</option><option value="A4P">A4 Portrait</option></select>
    <select value={fmt} onChange={e => setFmt(e.target.value)} aria-label="Format file" className="dfm-open" data-testid={`${tid}-fmt`}>
      <option value="svg">SVG (CorelDRAW)</option><option value="pdf">PDF vektor</option></select>
    <button type="button" className="dfm-open" disabled={busy} onClick={download} data-testid={`${tid}-download`}
      title="Opsional — alat bantu saja. Upload mockup manual dari CorelDRAW tetap bisa seperti biasa.">
      <FileDown size={12}/> {busy ? "Membuat…" : "Unduh Template (opsional)"}</button>
  </span>;
}
